import { render, staticRenderFns } from "./LoanTypesForm.vue?vue&type=template&id=0ac98a48"
import script from "./LoanTypesForm.vue?vue&type=script&lang=js"
export * from "./LoanTypesForm.vue?vue&type=script&lang=js"
import style0 from "./LoanTypesForm.vue?vue&type=style&index=0&id=0ac98a48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports